import type { CompanionCareRates } from '@/apps/provider/profile/__types__/RateTypes';
import { COMPANION_CARE_SERVICE_RATE_OPTIONS, type CompanionCareServiceRateOption } from '../__types__/CareTypeFormOptions';
import type { CompanionCareServiceRateFormEntry } from '../__types__/CompanionCareProfileTypes';

const getRateCents = (
  rates: CompanionCareRates | null | undefined,
  ratePath: CompanionCareServiceRateOption['ratePath']
): number | null => {
  if (!rates) return null;
  const [group, field] = ratePath.split('.') as [keyof CompanionCareRates, string];
  const groupRates = rates[group] as Record<string, number | undefined> | undefined;
  const value = groupRates?.[field];
  return typeof value === 'number' ? value : null;
};

export const ratesToServiceRateFormEntries = (
  rates: CompanionCareRates | null | undefined
): CompanionCareServiceRateFormEntry[] =>
  COMPANION_CARE_SERVICE_RATE_OPTIONS.map((option) => {
    const cents = getRateCents(rates, option.ratePath);
    return {
      service: option.service,
      selected: cents != null && cents > 0,
      rate: cents != null && cents > 0 ? String(Math.round(cents / 100)) : '',
    };
  });

export const serviceRateFormEntriesToUpsert = (
  entries: CompanionCareServiceRateFormEntry[]
): Array<{ service: string; rate: number }> =>
  entries
    .filter((entry) => entry.selected && entry.rate && Number(entry.rate) > 0)
    .map((entry) => ({
      service: entry.service,
      rate: Math.round(Number(entry.rate) * 100),
    }));
